var _defs, _circle, _rect, _rect2, _rect3, _circle2, _circle3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 82,
    y: 79.3,
    width: 310.9,
    height: 310.9
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 203.9,
    cy: 98.9,
    r: 73
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 79.3,
    width: 110.3,
    height: 50.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 321.7,
    y: 83.4,
    width: 153.4,
    height: 46.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 234.8,
    width: 229.6,
    height: 48.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.7,
    cy: 258.8,
    r: 69.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 417,
    r: 69.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 430.9,
    y: 234.8,
    width: 48.1,
    height: 48.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 390.2,
    width: 49.1,
    height: 49.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 254.5,
    y: 391.2,
    width: 220.5,
    height: 48.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.8c676170f7f2d04b14abe2cdab54a15a.svg";
export { ForwardRef as ReactComponent };